export default __webpack_public_path__ + "static/media/fox.0df2c120.jpg";